import { render } from "./ProfileSetting.vue?vue&type=template&id=664c2984"
import script from "./ProfileSetting.vue?vue&type=script&lang=js"
export * from "./ProfileSetting.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__